module.exports = __webpack_public_path__ + "media/images/main_arena-1d10997807e1e8182c6a2f9a0172cf87.png";